<template>
  <div id="newsletter" :style="'background-image: url(' + bkg + ')'">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="form-row">

          <div class="col-sm-12 col-md-12">
            <div class="title">
              Inscreva-se e receba nossas novidades
            </div>
          </div>
          <div class="col-sm-12 col-md-12">
            <form class="form-inline row">
              <div class="form-group col-md-6 offset-md-1">
                <input :readonly="readonly" class="form-control" type="email" name="email" v-model="email" placeholder="Informe seu E-mail"/>
                <small v-if="msg">{{msg}}</small>
                <small class="error" v-if="msgErro">{{msgErro}}</small>
                <small class="success" v-if="msgSucesso">{{msgSucesso}}</small>
              </div>
              <button class="btn col-md-4" v-on:click.stop.prevent="submit()">Enviar</button>
            </form>
          </div>
          </div>

        </div>
      </div>
    </div>
    <div class="opacity"></div>
  </div>
</template>

<script>
import { API } from '../../services/api'
import Functions from '../../utils/functions'
import bkg from '../../assets/images/inscrevase.jpg'

export default {
  data(){
    return {
      msg: null,
      readonly: false,
      email: null,
      msgSucesso: null,
      msgErro: null,
      bkg: bkg
    }
  },
  methods: {
    submit(){
      this.msgSucesso = null;
      this.msgErro = null;
      this.msg = null;
      this.readonly = true;
      this.msg = 'Aguarde...';
      if(this.validate()){
        this.$http.post(API.Contact.newsletter, {type: 'newsletter', email: this.email}).then((res) => {
          this.msgErro = null;
          this.msg = null;
          this.msgSucesso = res.body.message;
          this.readonly = false;
          this.email = null;
        }, (err) => {
          this.msgErro = err.body.message;
          this.msgSucesso = null;
          this.msg = null;
          this.readonly = false;
        });
      }else{
        this.readonly = false;
      }
    },
    validate(){
      if(!this.email){
        this.msg = 'Deve digitar um e-mail!';
        return false;
      }
      if(!Functions.validateEmail(this.email)){
        this.msg = 'Deve digitar um e-mail válido!';
        return false;
      }
      return true;
    },
    hideMsg(){

    }
  }
}
</script>

<style scoped lang="scss">
#newsletter{
  width: 100%;
  min-height: 200px;
  overflow: hidden;
  background-color: #000;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  @media screen and (max-width: 767px ){
    min-height: 260px;
  }

  .opacity{
    width: 100%;
    position: absolute;
    background-color: #000;
    min-height: 200px;
    z-index: 10;
    opacity: 0.4;
    @media screen and (max-width: 767px ){
      min-height: 250px;
    }
  }

  .form-group{
    @media screen and (max-width: 767px ){
      padding-left: 0px;
      padding-right: 0px;

      input{
        text-align: center;
      }
    }
  }

  .form-row{
    width: 100%;
    position: absolute;
    z-index: 20;
    margin-top: 50px;
    @media screen and(max-width: 767px){
      margin-top: 30px;
    }

    .title{
      color: #fff;
      font-family: RalewayRegular;
      font-size: 24px;
      text-align: center;
      text-shadow: 1px 1px 1px #000;

      span{
        color: #00AE39;
      }
    }

    .form-inline{
      @media screen and(max-width: 767px){
        text-align: center;
      }
      .form-group{
        padding-right: 0px;
      }
      input{
          padding: 27px;
          width: 100%;
          margin-top: 10px;
          border-radius: 0px;
          font-family: RalewayRegular;
          border-color: #00AE39;
      }
      small{
        position: absolute;
        top: 70px;
        font-size: 14px;
        color: yellow;
        text-shadow: 1px 1px 1px #000;
        &.success{
          color: #00AE39;
        }
        &.error{
          color: red;
        }
      }
      button{
        font-size: 28px;
        margin-top: 10px;
        padding-left: 30px;
        padding-right: 30px;
        border-radius: 0px;
        font-family: RalewayRegular;
        background-color: #00AE39;
        color: #fff;
        @media screen and(max-width: 767px){
          margin-top: 20px;
        }
      }
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/components/home/NewsletterSection.vue